export default function toEuros(integer) {
  return (integer / 100).toLocaleString('fr-FR', {
    style: 'currency',
    currency: 'EUR',
  })
}
